import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import EmailConfiguration from '../Templates/EmailConfiguration';
import { useParams } from 'react-router-dom';
import UserList from '../Users/UserListTable'; // Import UserList
import { deleteEmailTemplate, getEmailTemplates, saveEmailTemplate } from '../communicationApi';
import { useSnackbar } from '../../../../../Context/SnackbarContext';
import { removeSpacing } from '../../../../Common/Sanitize/sanitizeReactQuill';

export interface EmailTemplate {
    EmailNum: number;
    EmailSubject: string;
    EmailBody: string;
    IsUserTemplate: boolean
}

const ManageEmailTemplates: React.FC = () => {
    const [isMessageConfigured, setIsMessageConfigured] = useState(false);
    const [emailList, setEmailList] = useState<string>('');
    const [message, setMessage] = useState<string>('');
    const [selectedEmailId, setSelectedEmailId] = useState<number | null>(null); // State for selected email ID
    const [subject, setSubject] = useState('');
    const [emailTemplates, setEmailTemplates] = useState<EmailTemplate[]>([]);
    const { tenant } = useParams<{ tenant: string }>();
    const { showSnackbar } = useSnackbar();
    const tabName = 'Email';

    const fetchEmailTemplates = async () => {
        try {
            const response = await getEmailTemplates(tenant)
            setEmailTemplates(response);

        } catch (error) {
            console.error(error);
        }
    };
    // Fetch data on component mount
    useEffect(() => {
        fetchEmailTemplates();
    }, [tenant]);

    const handleSave = async (name: string, subject: string, body: string, emailNum: number | null) => {
        try {
            const emailBody= removeSpacing(body)
            const payLoad = {
                EmailSubject: subject,
                EmailBody: emailBody,
                EmailNum: emailNum ? emailNum : 0
            }
            const response = await saveEmailTemplate(tenant, payLoad)

            if (response) {
                showSnackbar(
                    `Email template has been ${emailNum ? 'updated' : 'created'}`,
                    'success'
                );

                if (emailNum) {
                    setEmailTemplates(prevTemplates =>
                        prevTemplates.map(template =>
                        (template.EmailNum === emailNum
                            ? { ...template, EmailSubject: subject, EmailBody: body }  // Update the existing template
                            : template)
                        )
                    );
                } else {
                    // If no emailNum, it's a new template, so we add it to the state
                    setEmailTemplates(prevTemplates => [
                        ...prevTemplates,
                        {
                            EmailNum: response.EmailNum, // Adjust according to your API response
                            EmailSubject: subject,
                            EmailBody: body,
                            IsUserTemplate: true
                        },
                    ]);
                }
            }
        } catch (error) {
            showSnackbar(
                `Failed to ${emailNum ? 'update' : 'create'} the email template. Please try again.`,
                'error'
            );
            console.error(error);
        }



    };

    const handleDelete = async (id: number | null) => {
        if (typeof id !== "number") {
            return
        }
        try {
            const payLoad = {
                EmailNum: id
            }
            const resposne = await deleteEmailTemplate(tenant, payLoad)
            if (resposne) {
                showSnackbar('Email template deleted successfully.', "success")
                setEmailTemplates(prevTemplates => prevTemplates.filter(template => template.EmailNum !== id));
            }
        } catch (error) {
            showSnackbar("Failed to delete email template.Pleas try again.", "error")
            console.log(error)
        }
    }

    const handleClearAll = () => {
        setEmailList('')
        setMessage('')
        setSelectedEmailId(null)
        setSubject('')
        setIsMessageConfigured(false)
    }


    return (
        <Box sx={{ margin: '2.0833vw 0', display: 'flex', width: '100%', flexDirection: 'column' }}>
            {/* Email Configuration */}
            <Box>
                <EmailConfiguration
                    emailList={emailList}
                    setEmailList={setEmailList}
                    setSubject={setSubject}
                    subject={subject}
                    message={message}
                    setMessage={setMessage}
                    handleSave={handleSave}
                    handleDelete={handleDelete}
                    setIsMessageConfigured={setIsMessageConfigured}
                    emailTemplates={emailTemplates} // Pass the fetched templates
                    setSelectedEmailId={setSelectedEmailId}
                    selectedEmailId={selectedEmailId}
                />
            </Box>

            {/* Conditionally show the UserList component */}
            <Box>
                {isMessageConfigured &&
                    <UserList
                        selectedEmailId={selectedEmailId}
                        handleClearAll={handleClearAll}
                        tabName={tabName}
                    />} {/* Show UserList if message is configured */}
            </Box>
        </Box>
    );
};

export default ManageEmailTemplates;
